import React from "react"
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"


export default function AppTransmissionAutocomplete({ ...props }) {
    return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
		label="Transmission"
		placeholder="Any transmission"
		{...props}
	/>
}